import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConsoleTriggerService {
  constructor() {}

  disableConsoleInProduction(): void {
    // console.log = function (): void {};
    // console.debug = function (): void {};
    // console.warn = function (): void {};
    // console.info = function (): void {};
    // console.error = function (): void {};
  }
}
